// extracted by mini-css-extract-plugin
export var buttonContent = "_3k-0";
export var centered = "_3k-1";
export var centeredFlex = "_3k-2";
export var errorText = "_3k-3";
export var icon = "_3k-4";
export var iconButtonContent = "_3k-5";
export var monospace = "_3k-6";
export var padded = "_3k-7";